<template>
    <div class="Left_nav_set">
        <template v-for="item in routes">

            <router-link v-if="!item.hidden && item.noDropdown && item.children.length > 0"
                :to="item.path + '/' + item.children[0].path">
                <el-menu-item :index="item.path + '/' + item.children[0].path">
                    <i v-if='item.icon' :class="item.icon"></i> {{ item.children[0].name }}
                </el-menu-item>
            </router-link>

            <el-submenu :index="item.key" v-if="!item.noDropdown && !item.hidden">
                <template slot="title">
                    <i v-if='item.icon' :class="item.icon"></i> {{ item.name }}
                </template>

                <template v-if="item.key == 'province_role'">
                    <el-menu-item-group>
                        <template slot="title">审核：</template>
                        <template v-for="(child, inx) in item.children" v-if='!child.hidden && inx < 3'>
                            <template v-if='child.isShow'>
                                <sidebar-item class='menu-indent' v-if='child.children && child.children.length > 0'
                                    :routes='[child]'> </sidebar-item>
                                <router-link v-else class="menu-indent" :to="item.path + '/' + child.path">
                                    <el-menu-item :style='bgSet(child.key)' :index="item.path + '/' + child.path">
                                        {{ child.name }}
                                    </el-menu-item>
                                </router-link>
                            </template>
                        </template>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <template slot="title">上报：</template>
                        <template v-for="(child, inx) in item.children" v-if='!child.hidden && inx >= 3 && inx < 5'>
                            <template v-if='child.isShow'>
                                <sidebar-item class='menu-indent' v-if='child.children && child.children.length > 0'
                                    :routes='[child]'> </sidebar-item>
                                <router-link v-else class="menu-indent" :to="item.path + '/' + child.path">
                                    <el-menu-item :style='bgSet(child.key)' :index="item.path + '/' + child.path">
                                        {{ child.name }}
                                    </el-menu-item>
                                </router-link>
                            </template>
                        </template>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <template slot="title">登记：</template>
                        <template v-for="(child, inx) in item.children" v-if='!child.hidden && inx >= 5 && inx < 8'>
                            <template v-if='child.isShow'>
                                <sidebar-item class='menu-indent' v-if='child.children && child.children.length > 0'
                                    :routes='[child]'> </sidebar-item>
                                <router-link v-else class="menu-indent" :to="item.path + '/' + child.path">
                                    <el-menu-item :style='bgSet(child.key)' :index="item.path + '/' + child.path">
                                        {{ child.name }}
                                    </el-menu-item>
                                </router-link>
                            </template>
                        </template>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <template slot="title">查询：</template>
                        <template v-for="(child, inx) in item.children" v-if='!child.hidden && inx >= 8'>
                            <template v-if='child.isShow'>
                                <sidebar-item class='menu-indent' v-if='child.children && child.children.length > 0'
                                    :routes='[child]'> </sidebar-item>
                                <router-link v-else class="menu-indent" :to="item.path + '/' + child.path">
                                    <el-menu-item :style='bgSet(child.key)' :index="item.path + '/' + child.path">
                                        {{ child.name }}
                                    </el-menu-item>
                                </router-link>
                            </template>
                        </template>
                    </el-menu-item-group>
                </template>

                <template v-else>

                    <template v-for="(child, inx) in item.children" v-if='!child.hidden'>
                        <template v-if='child.isShow'>
                            <sidebar-item class='menu-indent' v-if='child.children && child.children.length > 0'
                                :routes='[child]'> </sidebar-item>
                            <router-link v-else class="menu-indent" :to="item.path + '/' + child.path">
                                <el-menu-item :style='bgSet(child.key)' :index="item.path + '/' + child.path">
                                    {{ child.name }}
                                </el-menu-item>
                            </router-link>
                        </template>
                    </template>

                </template>





            </el-submenu>
        </template>
    </div>
</template>

<script>
export default {
    name: 'SidebarItem',
    props: {
        routes: {
            type: Array
        }
    },
    methods: {
        bgSet: function (key) {
            let bgMap = {
                'audio_exam': '#F2F6FC',
                'elect_exam': '#F2F6FC',
                'successive_exam': '#F2F6FC',
                'province_report': '#F2F6FC',
                'ss_report': '#F2F6FC',
                'audio_register': '#F2F6FC',
                'elect_register': '#F2F6FC',
                'ss_regist': '#F2F6FC'
            };

            // if(key == 'audio_exam'){
            //     return 'border-top:1px solid #e8e8e8;';
            // }else if(bgMap[key]){
            //     return 'border-bottom:1px solid #e8e8e8;';
            // }

            // return 'background:' + bgMap[key] + "!important;";


            // console.log(term);
        }
    },

    created: function () {


    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.Left_nav_set .svg-icon {
    margin-right: 10px;
}

.Left_nav_set .hideSidebar .menu-indent {
    display: block;
    text-indent: 10px;
}

.Left_nav_set .el-menu-item-group__title {
    // color: white;
    background: #E4E7ED;
}</style>



// WEBPACK FOOTER //
// SidebarItem.vue?1459d80b